<template>
  <div class="dataPage" :class="isFullScreen ? 'fullScreenPage' : ''">
    <div class="topTapBlock">
      <div class="leftTapBox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="数据看板" name="produceData">
            <div class="toolBar">
              <div class="titleBox">
                <span class="tableTitle">生产数据看板</span>
                <span :title="iconTitle" @click="fullScreen"
                  ><i class="el-icon-rank"></i
                ></span>
              </div>
              <div class="searchBox">
                <el-autocomplete
                  size="small"
                  class="inline-input"
                  v-model="keyWord"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                ></el-autocomplete>
                <el-button type="primary" @click="onSubmit" size="small"
                  >搜索</el-button
                >
                <!-- <el-button size="small" type="primary" @click="dialogVisible = true">导出</el-button> -->
                <el-button
                  size="small"
                  type="primary"
                  v-if="isAdmin"
                  @click="dialogVisible = true"
                >导出</el-button>
                <el-popconfirm v-if="isAdmin" title="确定删除40天未修改数据吗？" @confirm="deleteData()">
                  <el-button size="mini" type="danger" slot="reference"
                    >删除40天未动数据</el-button
                  >
                </el-popconfirm>
              </div>
            </div>
            <el-dialog
              title="导出"
              :visible.sync="dialogVisible"
              destroy-on-close
              width="90%"
            >
              <!-- 选择时间 -->
              <div class="date-ipt">
                <el-date-picker
                  v-model="value1"
                  type="datetime"
                  placeholder="选择日期时间"
                  align="right"
                >
                </el-date-picker>
                -
                <el-date-picker
                  v-model="value2"
                  type="datetime"
                  placeholder="选择日期时间"
                  align="right"
                >
                </el-date-picker>
                <el-button type="primary" @click="getExcelData">查询</el-button>
                <el-button type="primary" @click="handleExportMarketingList">导出Excel</el-button>
              </div>

              <el-table :data="excelDataList" style="width: 100%">
                <el-table-column>
                  <el-table-column :key="'model'" prop="model" label="产品型号">
                  </el-table-column>
                  <el-table-column
                    :key="'production_time'"
                    prop="production_time"
                    label="投产时间"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'warehousing_time'"
                    prop="warehousing_time"
                    label="入库时间"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'production_num'"
                    prop="production_num"
                    label="投产数量"
                  >
                  </el-table-column>
                </el-table-column>
                <!-- ----------- -->
                <!-- 成型 -->
                <el-table-column label="成型">
                  <el-table-column
                    :key="'received_num_cx'"
                    prop="received_num_cx"
                    label="到料数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'goodProduct_num_cx'"
                    prop="goodProduct_num_cx"
                    label="良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'badProduct_num_cx'"
                    prop="badProduct_num_cx"
                    label="不良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'yield_cx'"
                    prop="yield_cx"
                    label="良率"
                  >
                  </el-table-column>
                  <el-table-column label="不良">
                    <el-table-column
                      :key="'badSize_num_cx'"
                      prop="badSize_num_cx"
                      label="尺寸超差"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'badAppearance_num_cx'"
                      prop="badAppearance_num_cx"
                      label="外观颜色异常"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'badCombination_cx'"
                      prop="badCombination_cx"
                      label="结合不良"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'manyBad_cx'"
                      prop="manyBad_cx"
                      label="烧结融化、鼓包、孔洞、开裂"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'badArtificial_cx'"
                      prop="badArtificial_cx"
                      label="人为损坏"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'other_cx'"
                      prop="other_cx"
                      label="其它"
                    >
                    </el-table-column>
                  </el-table-column>
                </el-table-column>

                <!-- 放电 -->
                <el-table-column label="放电">
                  <el-table-column
                    :key="'received_num_fd'"
                    prop="received_num_fd"
                    label="到料数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'goodProduct_num_fd'"
                    prop="goodProduct_num_fd"
                    label="良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'badProduct_num_fd'"
                    prop="badProduct_num_fd"
                    label="不良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'yield_fd'"
                    prop="yield_fd"
                    label="良率"
                  >
                  </el-table-column>
                  <el-table-column label="不良原因">
                    <el-table-column
                      :key="'badSize_num_fd'"
                      prop="badSize_num_fd"
                      label="尺寸超差"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'manyBad1_fd'"
                      prop="manyBad1_fd"
                      label="掉砂、侧面裂纹、外观不良"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'manyBad2_fd'"
                      prop="manyBad2_fd"
                      label="烂头、尺寸问题、工艺不良"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'badArtificial_fd'"
                      prop="badArtificial_fd"
                      label="人为损坏"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'other_fd'"
                      prop="other_fd"
                      label="其他"
                    >
                    </el-table-column>
                  </el-table-column>
                </el-table-column>

                <!-- 品控 -->
                <el-table-column label="品控">
                  <el-table-column
                    :key="'received_num_pk'"
                    prop="received_num_pk"
                    label="到料数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'goodProduct_num_pk'"
                    prop="goodProduct_num_pk"
                    label="良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'badProduct_num_pk'"
                    prop="badProduct_num_pk"
                    label="不良品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'yield_pk'"
                    prop="yield_pk"
                    label="良率"
                  >
                  </el-table-column>
                  <el-table-column label="不良数">
                    <el-table-column
                      :key="'beat_pk'"
                      prop="beat_pk"
                      label="跳动大"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'diameter_pk'"
                      prop="diameter_pk"
                      label="直径问题"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'totalLength_pk'"
                      prop="totalLength_pk"
                      label="总长问题"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'angle_pk'"
                      prop="angle_pk"
                      label="角度问题"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'appearance_pk'"
                      prop="appearance_pk"
                      label="外观问题"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'incoming_pk'"
                      prop="incoming_pk"
                      label="来料不良"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'testScrap_pk'"
                      prop="testScrap_pk"
                      label="测试报废"
                    >
                    </el-table-column>
                    <el-table-column
                      :key="'other_pk'"
                      prop="other_pk"
                      label="其它"
                    >
                    </el-table-column>
                  </el-table-column>
                </el-table-column>

                <el-table-column>
                  <el-table-column
                    :key="'warehousing_num'"
                    prop="warehousing_num"
                    label="入库数"
                  >
                  </el-table-column>
                  <el-table-column
                    :key="'through'"
                    prop="through"
                    label="产品直通率"
                  >
                  </el-table-column>
                </el-table-column>
              </el-table>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleExportMarketingList">导出Excel</el-button>
              </span>
            </el-dialog>
            <!-- 生产数据看板表格 -->
            <div class="tableBox">
              <el-table
                :data="produceTableData"
                :height="freeHeight"
                v-loading="produceLoading"
                border
                :cell-class-name="'cellClass'"
                :stripe="true"
              >
                <el-table-column
                  :key="'type_name'"
                  prop="type_name"
                  label="型号"
                  min-width="120px"
                  sortable
                >
                  <template slot-scope="scope">
                    <a
                      href=""
                      style="color: #409eff"
                      @click.prevent="viewHistory(scope.row.model_type)"
                      >{{ scope.row.type_name }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type_customer"
                  label="客户"
                  min-width="120px"
                  sortable
                >
                  <template slot-scope="scope">
                    {{scope.row.type_customer}}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in produceTableHead"
                  :key="index"
                  :label="item.label"
                  :width="item.width"
                  :prop="item.prop"
                  sortable
                >
                  <el-table-column
                    :label="`${addNum[index]}`"
                    :prop="item.prop"
                    :width="item.width"
                  >
                  </el-table-column>
                </el-table-column>
                <el-table-column label="操作" v-if="isAdmin">
                  <template slot-scope="scope">
                    <el-popconfirm title="确定删除该型号吗？" @confirm="deleteOneData(scope.row.model_type)">
                      <el-button size="mini" type="danger" slot="reference"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <div class="toolBar" style="margin-top: 16px">
                <span class="tableTitle">生产计划看板</span>
              </div>
              <el-table
                :data="planTableData"
                :height="freeHeight"
                border
                :cell-class-name="'cellClass'"
                :stripe="true"
              >
                <el-table-column
                  v-for="(item, index) in planTableHead"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                ></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="isManager" label="生产计划" name="producePlan">
            <div class="toolBar">
              <div class="titleBox">
                <span class="tableTitle">制定生产计划</span>
              </div>
              <div class="toolBox">
                <el-date-picker
                  v-model="planDate"
                  type="date"
                  placeholder="选择日期"
                  size="small"
                  @change="changePlanDate"
                >
                </el-date-picker>
                <el-button
                  type="primary"
                  @click.native.prevent="addPlan"
                  size="small"
                  >+新增计划</el-button
                >
              </div>
            </div>
            <div class="tableBox">
              <el-table
                :data="createPlanData"
                border
                :cell-class-name="'cellClass'"
                :stripe="true"
                :height="400"
                v-loading="planLoading"
              >
                <el-table-column
                  v-for="(item, index) in createPlanHead"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                ></el-table-column>
                <el-table-column label="操作" v-if="isAdmin">
                  <template slot-scope="scope">
                    <el-popconfirm title="确定删除该型号吗？" @confirm="deleteOnePlanData(scope.row.id)">
                      <el-button size="mini" type="danger" slot="reference"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>

              <div class="pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="planCurrentPage"
                  :page-sizes="[10, 20, 30]"
                  :page-size="planPageSize"
                  layout="sizes,prev,pager"
                  :total="planListTotal"
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="库存管理" v-if="false && isManager" name="stockManage">
            <div class="toolBar">
              <div class="searchBox">
                <el-select
                  v-model="stockType"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  size="small"
                  @change="changeStockType"
                >
                  <el-option
                    v-for="item in stockItems"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="titleBox">
                <el-button
                  slot="reference"
                  @click.native.prevent="addStock"
                  type="primary"
                  size="small"
                  >+{{ stockType }}</el-button
                >
              </div>
            </div>
            <div class="tableBox">
              <el-table
                :data="stockTableData"
                border
                :cell-class-name="'cellClass'"
                :stripe="true"
                :height="500"
                v-loading="stockLoading"
              >
                <el-table-column
                  v-for="(item, index) in stockTableHead"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width"
                ></el-table-column>

                <el-table-column label="操作" width="300">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="editStock(scope.$index)"
                      plain
                      size="small"
                    >
                      修改
                    </el-button>

                    <el-button
                      v-show="stockType == '产品入库'"
                      @click.native.prevent="secondHandle(scope.$index)"
                      plain
                      size="small"
                    >
                      二次处理
                    </el-button>

                    <el-popconfirm
                      title="确定删除此条记录吗？"
                      @confirm="deleteStock(scope.$index)"
                    >
                      <el-button slot="reference" type="danger" size="small"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="rightTabBox">
        {{ time }}
      </div>

      <plan-pop
        v-if="showPlanEdit"
        :rowData="rowData"
        @close="closePlanPop"
        @save="savePlan"
      />

      <stock-pop
        v-if="showStockEdit"
        :rowData="rowStockData"
        :stockType="stockType"
        @close="closeStockPop"
        @save="saveStock"
      />

      <second-handle
        v-if="showSecondHandle"
        :rowData="rowStockData"
        @close="closeSecondHandlePop"
        @save="saveSecondHandle"
      />
    </div>

    <div class="midTableBlock"></div>

    <div class="botTableBlock"></div>
  </div>
</template>

<script>
import planPop from "./pop/planPop.vue";
import { timestampToTime } from "../../utils/util";
import PlanPop from "./pop/planPop.vue";
import secondHandle from "./pop/secondHandle.vue";
import stockPop from "./pop/stockPop.vue";
import {
  getPlan,
  addPlan,
  delPlan,
  setPlan,
  getHistory,
  deleteProduce,
  getScrap,
  getProduceList,
  getPlanList,
  getStockList,
  setStock,
  delStock,
  inStock,
  secondStock,
  getJCStockList,
  setJC,
  delJC,
  addJC,
  outExcelData,
  deletelModelType,
  deletelPlanData
} from "../../api/process";
import { Message } from "element-ui";
import formatDate from "../../utils/formatDate";
export default {
  name: "homeIn",
  components: { planPop, stockPop, secondHandle },
  data() {
    return {
      timer: null, //定时器
      isManager: false,
      isFullScreen: false,
      iconTitle: "全屏",
      showStockEdit: false,
      newStock: "",
      dialogVisible: false,
      rowStockData: "",
      stockType: "产品入库",
      showSecondHandle: false,
      produceLoading: true,
      planLoading: false,
      stockLoading: false,
      eatchPRoduceList:false,
      isAdmin:false,
      stockItems: [
        { value: "产品入库", label: "产品入库" },
        { value: "基材入库", label: "基材入库" }
      ],
      value1: "",
      value2: "",
      stockTableData1: [],
      json_fields: {
        成型: {
          到料数量: "投产"
        },
        放电: {
          到料数量: "投产",
          良品数量: "投产",
          不良品数量: "投产"
        },
        品控: {
          到料数量: "投产",
          良品数量: "投产",
          不良品数量: "投产"
        }
      },
      stockTableHead1: [
        {
          prop: "model_type",
          label: "型号"
        },
        {
          prop: "quality_number",
          label: "合格品"
        },
        {
          prop: "unquality_number",
          label: "不合格品"
        }
      ],
      stockTableData2: [],
      stockTableHead2: [
        { prop: "model_type", label: "型号" },
        { prop: "quantity", label: "数量" }
      ],
      stockTableData: [],
      stockTableHead: [],
      activeName: "produceData",
      rowData: "",
      newPlan: "",
      showPlanEdit: false,
      keyWord: "",
      time: "",
      planDate: "",
      excelDataList: [],
      produceTableData: [],
      produceTableHead: [
        {
          prop: "jcs",
          label: "基材"
          // width: 100,
        },
        {
          prop: "tc",
          label: "投产"
          // width: 100,
        },
        {
          prop: "cx",
          label: "成型"
          // width: 100,
        },
        {
          prop: "fd",
          label: "放电"
          // width: 100,
        },
        {
          prop: "pk",
          label: "品控"
          // width: 100,
        },
        {
          prop: "rk",
          label: "入库"
          // width: 100,
        },
        {
          prop: "bls",
          label: "不良数"
          // width: 100,
        },
        {
          prop: "xcs",
          label: "现场数"
          // width: 100,
        },
        {
          prop: "yrks",
          label: "月入库数"
          // width: 100,
        },
        {
          prop: "ybfs",
          label: "月报废数"
          // width: 100,
        },
        {
          prop: "ybfl",
          label: "月报废率"
          // width: 100,
        }
      ],
      planTableData: [],
      planTableHead: [],
      planColWidth: "",
      freeHeight: "",
      createPlanDataLen: 0,
      createPlanData: [],
      sum_date: {},
      createPlanHead: [
        {
          prop: "name",
          label: "名称"
        },
        {
          prop: "model_type",
          label: "型号"
        },
        {
          prop: "quantity",
          label: "计划数量"
        },
        {
          prop: "date_time",
          label: "生产日期"
        }
      ],
      options: [
        {
          value: "小批量",
          label: "小批量"
        },
        {
          value: "砥石",
          label: "砥石"
        },
        {
          value: "打样",
          label: "打样"
        },
        {
          value: "测试",
          label: "测试"
        }
      ],
      planCurrentPage: 1,
      planPageSize: 10,
      planListTotal: 0
    };
  },
  computed: {
    filterExcel() {
      const newArr = []
      this.excelDataList.forEach((item, index) => {
        const arr = []
        arr[0] = item['model']
        arr[1] = item['production_time']
        arr[2] = item['warehousing_time']
        arr[3] = item['production_num']
        arr[4] = item['received_num_cx']
        arr[5] = item['goodProduct_num_cx']
        arr[6] = item['badProduct_num_cx']
        arr[7] = item['yield_cx']
        arr[8] = item['badSize_num_cx']
        arr[9] = item['badAppearance_num_cx']
        arr[10] = item['badCombination_cx']
        arr[11] = item['manyBad_cx']
        arr[12] = item['badArtificial_cx']
        arr[13] = item['other_cx']
        arr[14] = item['received_num_fd']
        arr[15] = item['goodProduct_num_fd']
        arr[16] = item['badProduct_num_fd']
        arr[17] = item['yield_fd']
        arr[18] = item['badSize_num_fd']
        arr[19] = item['manyBad1_fd']
        arr[20] = item['manyBad2_fd']
        arr[21] = item['badArtificial_fd']
        arr[22] = item['other_fd']
        arr[23] = item['received_num_pk']
        arr[24] = item['goodProduct_num_pk']
        arr[25] = item['badProduct_num_pk']
        arr[26] = item['yield_pk']
        arr[27] = item['beat_pk']
        arr[28] = item['diameter_pk']
        arr[29] = item['totalLength_pk']
        arr[30] = item['angle_pk']
        arr[31] = item['appearance_pk']
        arr[32] = item['incoming_pk']
        arr[33] = item['testScrap_pk']
        arr[34] = item['other_pk']
        arr[35] = item['warehousing_num']
        arr[36] = item['through']
        newArr[index] = arr
      })
      return newArr

    },
    addNum() {
      const addArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      console.log(this.produceTableData);
      this.produceTableData.forEach(item => {
        addArr[0] += item["tc"];
        addArr[1] += item["cx"];
        addArr[2] += item["fd"];
        addArr[3] += item["pk"];
        addArr[4] += item["stock"];
        addArr[5] += item["bls"];
        addArr[6] += item["xcs"];
        addArr[7] += item["yrks"];
        addArr[8] += item["ybfs"];
        // let newNum = item["ybfl"].toString().replace(/%/g, "");
        // addArr[9] += Number(newNum);
      });
      addArr[9] = this.sum_date.sum_ybfl;
      return addArr;
    }
  },
  created() {
    this.getTime();
    this.isManager = localStorage.getItem("role_id") == 0 ? true : false;
    // this.getProduceListData();
    // this.getscrapListData();
    this.interGetData();
    this.getPanelPlan();
    if (localStorage.getItem("role_id") === '0') {
      this.isAdmin = true
    }
  },
  mounted() {
    this.calcTableWidth();
    let that = this;
    addEventListener("resize", function() {
      that.calcTableWidth();
    });
  },
  beforeUpdate() {},
  beforeDestroy() {
    removeEventListener("resize", function() {
      that.calcTableWidth();
    });
  },
  methods: {
    querySearch(queryString, cb) {
      cb([
        { value: "小批量" },
        { value: "砥石" },
        { value: "测试" },
        { value: "打样" }
      ]);
    },

    changePlanDate(e) {
      console.log(e);
      let nDate = "";
      if (e) {
        nDate = formatDate(e, "YYYY-MM-DD");
      } else {
        nDate = "";
      }

      this.getPlanListData(nDate);
    },

    //生产数据筛选型号
    handleSelect(item) {
      console.log(item.value);
      this.keyWord = item.value;
    },

    calcTableWidth() {
      let page = document.querySelector(".index-main");
      if (!page) {
        return;
      }
      let tab = document.querySelector(".el-tabs__header");
      let title = document.querySelector(".tableTitle");

      let wid = page && page.getBoundingClientRect().width;
      let hei = page && page.getBoundingClientRect().height;

      let freeHeight =
        hei -
        tab.getBoundingClientRect().height -
        2 * title.getBoundingClientRect().height -
        64;
      let freeWidth = wid - 64;
      this.freeHeight = freeHeight / 2 + "px";
      this.freeWidth = freeWidth / 6 + "px";

      console.log(this.freeHeight, this.freeWidth);
    },

    handleClick(e) {
      console.log(e);
      if (this.activeName == "stockManage") {
        // this.stockTableHead = this.stockTableHead1;
        // this.stockTableData = this.stockTableData1;
        //  this.getJCListData();
        clearInterval(this.timer);
        this.getStockListData();
      } else if (this.activeName == "producePlan") {
        clearInterval(this.timer);
        this.getPlanListData();
      } else if (this.activeName == "produceData") {
        this.keyWord = "";
        this.interGetData();
        this.getPanelPlan();
      }
    },

    interGetData() {
      let that = this;
      that.getProduceListData();
      this.timer = setInterval(() => {
        if (!that.produceLoading && that.eatchPRoduceList) {
          that.getProduceListData();
        }
      });
    },

    getTime() {
      let that = this;
      setInterval(() => {
        that.time = timestampToTime(new Date());
      }, 1000);
    },
    getCellStyle(obj) {
      return {
        padding: "2px"
      };
    },
    //检索看板数据
    onSubmit() {
      clearInterval(this.timer);
      this.produceLoading = false;
      this.interGetData();
    },
    getPlanListData(d) {
      let date = d ? d : "";
      let that = this;
      // that.planLoading = true;
      getPlan({
        date_time: date,
        per_page: this.planPageSize,
        page: this.planCurrentPage
      })
        .then(res => {
          console.log(res);
          that.createPlanData = res.data.data;

          that.createPlanDataLen = res.data.tatal;
          that.planListTotal = res.data.tatal;
          that.planLoading = false;

          // let data=res.data
          // data.map((item,index)=>{

          // })
        })
        .catch(e => {
          that.planLoading = false;
        });
    },
    getStockListData() {
      let that = this;
      that.stockLoading = true;
      getStockList()
        .then(res => {
          that.stockTableHead = that.stockTableHead1;
          that.stockTableData = res.data;
          that.stockLoading = false;
        })
        .catch(e => {
          that.stockTableHead = that.stockTableHead1;
          that.stockTableData = [];
          that.stockLoading = false;
        });
    },
    getJCListData() {
      let that = this;
      that.stockLoading = true;
      console.log("获取基材");
      getJCStockList()
        .then(res => {
          that.stockTableHead = that.stockTableHead2;
          that.stockTableData = res.data;
          that.stockLoading = false;
        })
        .catch(e => {
          that.stockTableHead = that.stockTableHead2;
          that.stockTableData = [];
          that.stockLoading = false;
        });
    },

    reNameKey(key) {
      let result = "";
      switch (key) {
        case "jcs":
          result = "基材";
          break;
        case "model_type":
          result = "型号";
          break;
        case "stock":
          result = "库存";
          break;
        default:
          result = key;
          break;
      }
      return result;
    },
    getProduceListData() {
      let that = this;
      this.eatchPRoduceList = false
      getProduceList({ keyWord: that.keyWord })
        .then(res => {
          let allhead = [];
          res.data.stockTableHead.map(item => {
            if (item.label != "预投产") {
              allhead.push(item);
            }
          });
          let lasthead = [
            {
              prop: "stock",
              label: "入库数"
              // width: 100,
            },
            {
              prop: "bls",
              label: "日不良数"
              // width: 100,
            },
            {
              prop: "xcs",
              label: "现场数"
              // width: 100,
            },
            {
              prop: "yrks",
              label: "月入库数"
              // width: 100,
            },
            {
              prop: "ybfs",
              label: "月报废数"
              // width: 100,
            },
            {
              prop: "ybfl",
              label: "月报废率"
              // width: 100,
            }
          ];
          allhead = allhead.concat(lasthead);
          that.produceTableHead = allhead;

          getScrap({ date_time: formatDate(new Date(), "YYYY-MM-DD") , keyWord: that.keyWord })
            .then(res2 => {
              console.log(res2);
              let data = res2.data;
              this.sum_date = res2.sum_date
              let arr = [];
              data.map((item1, index) => {
                res.data.all_data_list.map((item2, index2) => {
                  if (item1.model_type == item2.model_type) {
                    arr.push({ ...item1, ...item2 });
                  }
                });
              });
              that.produceTableData = arr;
              that.produceLoading = false;
              that.eatchPRoduceList = true;
            })
            .catch(e => {
              that.produceLoading = false;
              that.eatchPRoduceList = true;
            });
           
        })
        .catch(e => {
          that.produceLoading = false;
          that.eatchPRoduceList = true;
        });
    },
    // 导出
    handleExportMarketingList() {
      if (this.filterExcel.length === 0) return this.$message.warning('请先筛选需要导出的数据！')
      // 懒加载，@/common/vendor/Export2Excel 此路径为本地路径
      import("@/common/vendor/Export2Excel").then(excel => {
        const multiHeader = [
          ["", "", "", "", "成型", "", "", "", "", "", "", "", "", "", "放电", "", "", "", "", "", "", "", "","品控", "", "", "", "", "", "", "", "", "", "", "", "", ""]
        ];
        const multiHeader2 = [["产品型号", "投产时间", "入库时间", "投产数量", "到料数量", "良品数量", "不良品数量", "良率", "不良", "", "", "", "", "", "到料数量", "良品数量", "不良品数量", "良率", "不良原因", "", "", "", "", "到料数量", "良品数量", "不良品数量", "良率", "不良数", "", "", "", "", "", "", "", "入库数", "产品直通率"]];
        const tHeader = ["","","","","","","","","尺寸超差","外观颜色异常","结合不良","烧结融化、鼓包、孔洞、开裂","人为损坏","其它", "", "", "", "", "尺寸超差", "掉砂、侧面裂纹、外观不良","烂头、尺寸问题、工艺不良", "人为损坏", "其它", "", "", "","", "跳动大", "直径问题", "总长问题","角度问题", "外观问题", "来料不良", "测试报废","其它","",""];
        const filterVal = ["id", "name", "age"]; // 表头所对应的字段，这里未填写，请自行填写对应的字段
        const data = this.filterExcel;
        // 进行所有表头的单元格合并
        const merges = ["E1:N1", "O1:W1", "X1:AI1", "I2:N2", "S2:W2", "AB2:AI2","A2:A3","B2:B3","C2:C3","D2:D3","E2:E3","F2:F3","G2:G3","H2:H3","O2:O3","P2:P3","Q2:Q3","R2:R3","X2:X3","Y2:Y3","Z2:Z3","AA2:AA3","AJ2:AJ3","AK2:AK3"];

        excel.export_json_to_excel({
          multiHeader, // 这里是第一行的表头
          multiHeader2, // 这里是第二行的表头
          header: tHeader, // 这里是第三行的表头
          data,
          filename: "data",
          merges
        });
      });
    },
    getExcelData() {
      if (!this.value1) return this.$message.error("请选择开始时间");
      let nowTime = this.value1; // Date Thu Dec 02 2021 16:10:53 GMT+0800 (中国标准时间)
      let start_time =
        nowTime.getFullYear() +
        "-" +
        (nowTime.getMonth() + 1) +
        "-" +
        nowTime.getDate() +
        " " +
        nowTime.getHours() +
        ":" +
        nowTime.getMinutes() +
        ":" +
        nowTime.getSeconds();

      if (!this.value2) return this.$message.error("请选择结束时间");
      if (this.value1.getTime() > this.value2.getTime())
        return this.$message.error("开始时间需小于结束时间");
      nowTime = this.value2;
      let end_time =
        nowTime.getFullYear() +
        "-" +
        (nowTime.getMonth() + 1) +
        "-" +
        nowTime.getDate() +
        " " +
        nowTime.getHours() +
        ":" +
        nowTime.getMinutes() +
        ":" +
        nowTime.getSeconds();
      outExcelData({ start_time, end_time }).then(res => {
        if (res.status === 200) {
          res.total['model'] = '合计'
          this.excelDataList = res.data
          this.excelDataList.push(res.total)
        }
      });
    },

    getscrapListData() {},
    //获取看板计划
    getPanelPlan() {
      let that = this;
      getPlanList()
        .then(res => {
          let list = res.data;
          let head = [
            {
              prop: "model_type",
              label: "型号\\日期"
            }
          ];
          for (let i = 0; i < 15; i++) {
            let curDate = new Date();
            let nextDate = curDate.setDate(curDate.getDate() + i);
            let date = formatDate(nextDate, "YYYY-MM-DD");
            let obj = {
              prop: date,
              label: date
            };
            head.push(obj);
          }
          that.planTableHead = head;
          that.planTableData = res.data;
        })
        .catch(e => {});
    },
    addPlan() {
      console.log("增加计划");
      this.rowData = "";

      this.showPlanEdit = true;
    },
    addStock() {
      this.rowStockData = "";
      this.showStockEdit = true;
    },

    editPlan(index, data) {
      this.rowData = this.createPlanData[index];
      this.showPlanEdit = true;
    },
    editStock(index, data) {
      this.rowStockData = this.stockTableData[index];
      this.showStockEdit = true;
    },
    secondHandle(index, data) {
      this.rowStockData = this.stockTableData[index];
      this.showSecondHandle = true;
    },
    deleteStock(index, data) {
      let that = this;
      if (this.stockType == "产品入库") {
        delStock({ id: this.stockTableData[index].id })
          .then(res => {
            Message.success("成功删除一条记录");
            that.getStockListData();
          })
          .catch(e => {});
      } else {
        delJC({ id: this.stockTableData[index].id })
          .then(res => {
            Message.success("成功删除一条记录");
            that.getJCListData();
          })
          .catch(e => {});
      }
    },
    deleteData() {
      deleteProduce().then(res => {
        if (res && res.status === 200) {
          this.$message.success(res.data);
        }
      });
    },
    deleteOneData(model_type) {
      console.log(model_type)
      deletelModelType({model_type}).then(res => {
        if (res.status === 200) {
          this.$message.success('删除成功！')
          this.getProduceListData()
        }
      })
    },
    deleteOnePlanData(id) {
      deletelPlanData({id}).then(res => {
       if(res.status === 200) {
          this.$message.success('删除成功!')
        }
      })
    },
    deletePlan(index, data) {
      let that = this;
      delPlan({ id: this.createPlanData[index].id })
        .then(res => {
          Message.success("删除生产计划成功");
          that.getPlanListData();
        })
        .catch(e => {});
    },
    closePlanPop() {
      this.showPlanEdit = false;
    },
    closeStockPop() {
      this.showStockEdit = false;
    },

    saveStock(data) {
      this.newStock = data;
      data["date_time"] = formatDate(new Date(), "YYYY-MM-DD hh:mm:ss");
      this.showStockEdit = false;
      console.log(data);
      let that = this;
      if (this.stockType == "产品入库") {
        if (this.rowStockData) {
          //修改产品入库
          setStock(data)
            .then(res => {
              Message.success("修改产品库存成功");
              that.getStockListData();
            })
            .catch(e => {});
        } else {
          inStock(data)
            .then(res => {
              Message.success("新增产品库存成功");
              that.getStockListData();
            })
            .catch(e => {});
        }
      } else {
        if (this.rowStockData) {
          //修改产品入库
          setJC(data)
            .then(res => {
              Message.success("修改基材库存成功");
              that.getJCListData();
            })
            .catch(e => {});
        } else {
          addJC(data)
            .then(res => {
              Message.success("新增基材库存成功");
              that.getJCListData();
            })
            .catch(e => {});
        }
      }
    },
    savePlan(data) {
      console.log(data);
      let that = this;
      if (this.rowData) {
        //修改
        setPlan(data)
          .then(res => {
            Message.success("修改生产计划成功");
            that.getPlanListData();
          })
          .catch(e => {});
      } else {
        addPlan(data)
          .then(res => {
            Message.success("新增生产计划成功");
            that.getPlanListData();
          })
          .catch(e => {});
      }
      this.showPlanEdit = false;
    },

    saveSecondHandle(data) {
      let d = {};
      let that = this;
      d["model_id"] = data["id"];
      d["model_type"] = data["model_type"];
      d["date_time"] = formatDate(new Date(), "YYYY-MM-DD hh:mm:ss");
      d["num"] = Number.parseInt(data["quality_number"]);
      d["scrap_num"] = Number.parseInt(data["scrap_num"]);
      d["warehouse_num"] = Number.parseInt(data["warehouse_num"]);
      d["type"] = data["type"];
      secondStock(d)
        .then(res => {
          Message.success("处理成功");
          that.getStockListData();
          that.showSecondHandle = false;
        })
        .catch(e => {});
    },
    closeSecondHandlePop() {
      this.showSecondHandle = false;
    },

    changeStockType() {
      if (this.stockType == "产品入库") {
        // this.stockTableData = this.stockTableData1;
        // this.stockTableHead = this.stockTableHead1;
        this.getStockListData();
      } else {
        // this.stockTableData = this.stockTableData2;
        // this.stockTableHead = this.stockTableHead2;
        this.getJCListData();
      }
    },

    viewHistory(type) {
      this.$router.push({
        path: "/produceDataManage/history",
        query: { model_type: type }
      });
    },
    fullScreen() {
      if (!this.isFullScreen) {
        this.isFullScreen = true;
        this.iconTitle = "退出全屏";
      } else {
        this.isFullScreen = false;
        this.iconTitle = "全屏";
      }
    },
    handleSizeChange(size) {
      this.planPageSize = size;
      this.getPlanListData();
    },
    handleCurrentChange(current) {
      this.planCurrentPage = current;
      this.getPlanListData();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less">
.cellClass {
  padding: 6px !important;
}
.fullScreenPage {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 99;
  background: white;
}
.pagination {
  padding: 30px;
  text-align: right;
}
.dataPage {
  .topTapBlock {
    position: relative;
    .leftTapBox {
      max-width: 100%;
      .toolBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
      }
    }

    .rightTabBox {
      padding: 8px;
      border-radius: 32px;
      position: absolute;
      color: white;
      background: #409eff;
      top: 0;
      right: 0;
    }
  }
  .midTableBlock {
  }
  .botTableBlock {
  }
  .date-ipt {
    text-align: right;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/produceDataManage/index.vue